import { render } from "./UpgradeChampion.vue?vue&type=template&id=825acf34"
import script from "./UpgradeChampion.vue?vue&type=script&lang=js"
export * from "./UpgradeChampion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/champions/windowOverlay/UpgradeChampion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "825acf34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('825acf34', __exports__)) {
    api.reload('825acf34', __exports__)
  }
  
  module.hot.accept("./UpgradeChampion.vue?vue&type=template&id=825acf34", () => {
    api.rerender('825acf34', render)
  })

}


export default __exports__